import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

/**
 * @tags styled, link, navigation
 */
const Link = styled.a.attrs(props => ({ 'data-qa': props.qa }))`
  cursor: pointer;
  text-decoration: none;
  
  ${({
    theme,
    active
  }) => css`
    color: ${theme.colors.primary.purple};
    
    ${!active && css`
      cursor: default;
      pointer-events: none;
    `};
  `};
  
  &:hover {
    text-decoration: underline;
  }
`;

Link.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
  qa: PropTypes.string
};

Link.defaultProps = {
  active: true,
  qa: undefined
};

/** @component */
export default Link;
